@if (item) {
  <div class="flex flex-row justify-between flex-nowrap center-v pt-3 pb-3">
    <div class="flex flex-col flex-nowrap pl-3 pr-3 border-box">
      <div class="flex flex-row items-center">
        <span class="text-sm color-light">{{ item.itemScanBean?.artikel?.nummer }}</span>
        @if (item?.files?.length) {
          <i class="fa-regular fa-images info-icon"></i>
        }
        @if (item?.vermerk?.length) {
          <i class="fa-regular fa-note-sticky info-icon"></i>
        }
      </div>
      @if (item.itemScanBean.artikel.artbez1?.length) {
        <p class="text-base font-semibold mt-1 mb-1">{{ item.itemScanBean.artikel.artbez1 }}</p>
      }
      @if (item.itemScanBean.artikel.artbez3?.length) {
        <p class="text-base font-semibold mt-1 mb-1">{{ item.itemScanBean.artikel.artbez2 }}</p>
      }
      @if (item.itemScanBean.artikel.artbez2?.length) {
        <p class="text-base font-semibold mt-1 mb-1">{{ item.itemScanBean.artikel.artbez3 }}</p>
      }
    </div>
    <div class="flex flex-row justify-end flex-nowrap center-v pl-3 border-box ">
      <div class="flex relative">
        <ng-container>
          <soft-number-input placeholder="Menge"
            [value]="item.itemScanBean?.menge ?? null"
            changeTrigger="input"
            style="max-width: 80px"
            (valueChange)="onChange($safeNavigationMigration(menge?.value()))"
            #menge>
          </soft-number-input>
          <div style="width: 100px;" class="ml-2">
            <span class="soft-title ml-3 color-light"
            style="width: 100px">{{ item.itemScanBean.einheit.arteh || ''}}</span>
          </div>
        </ng-container>
      </div>
      <span class="detail-area">
        <i class="fa-regular fa-trash pointer p-1"
          [ngStyle]="{ 'color': (!!(item.itemScanBean?.menge) || !!menge?.value()) ? 'var(--colorError)' : 'rgba(0, 0, 0, 0.33)'}"
        (click)="onDelete(); menge.value.set(null)"></i>
      </span>
    </div>
  </div>
}
